import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { getCompanyThemes } from 'reducers/securityCompany';
import { LinearProgress } from '@material-ui/core';
import { ROLES } from 'utils/constants';
import { getUserRoles } from 'reducers/users';
import PropTypes from 'prop-types';

const ParentWrapper = ({ children }) => {
  const authenticated = useSelector(state => state.auth.authenticated);
  const themes = useSelector(state => getCompanyThemes(state));
  const roles = useSelector(state => getUserRoles(state));

  if (
    authenticated &&
    isEmpty(themes) &&
    roles &&
    !roles.includes(ROLES.SRM_EMPLOYEE.id) &&
    !roles.includes(ROLES.SRM_ADMIN.id)
  ) {
    return <LinearProgress />;
  }

  return children;
};

ParentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ParentWrapper;
